module.exports = __webpack_public_path__ + "static/media/default-profile-picture.f9e4d92f.png";